<a [routerLink]="['/citas-list']" [queryParams]="{
     sede: '',
     servicio: '',
     especialidad: '',
     tipoEspecialista: '',
     nombreEspecialista: nombreEspecialista
   }">
  {{nombreEspecialista}}
</a>